import { ThemeUICSSObject } from '@apia/theme';

const header: ThemeUICSSObject = {
  '&.headerBox': {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignContent: 'center',
    flexWrap: 'wrap',
    gap: 3,
    paddingTop: 3,
    position: 'absolute',
    right: 3,
  },
  '.scaleCombo': {
    height: '100%',
  },
};

export default header;
